// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__17Z66","right":"styles_right__2p_h5"};